var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"font-weight-bold"},[_vm._v("КР за которые отвечает аналитик:")]),_c('ul',_vm._l((_vm.filteredClinRecs),function(cr){return _c('li',{key:cr.id},[_vm._v(" "+_vm._s(cr.name)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }